// @flow
import * as React from 'react';
import { Typography } from '@mui/material';

type Props = {
  value?: boolean | null
};
export const Tobacco = ({ value }: Props) => (
  <Typography fontWeight={500} fontSize={14} component={'span'} color={`${value ? 'error' : 'success'}.500`}>
    {typeof value === 'boolean' ? value  ? 'Yes' : 'No' : ''}
  </Typography>
)
